/*
 * 戒导航 · 内容审核 —— 前台「内容审核留痕记录」模型
 *
 * 设计依据：doc/发帖与配图内容审核设计方案.md（v1.0）§11.4「通知三件套」。
 *
 * 这个类的前台用途只有一个：**作为通知 subject 的占位模型**，
 * 让通知接口返回的 subject 资源能进入 app.store（详见 ./extend.ts 的 ① 段说明）。
 * 组件本身并不读取它的字段（通知正文所需的快照全部在 notification.content() 里，
 * 见 ContentReviewViolationNotification / ContentViolationBlueprint::getData()）。
 *
 * 属性与后端一一对应（只读，记录行是处置凭证，客户端不允许改写）：
 *   JieDH\ContentReview\Api\Resource\ContentReviewResource::fields()
 * type 名 'contentReviews' 必须与 ContentReviewResource::type() 完全一致。
 *
 * 范本：packages/avatar-guard/js/src/forum/models/SecondReview.ts
 */
import Model from 'flarum/common/Model';

/**
 * 内容审核留痕记录（记录一条「阿里云已放行内容」的抽查待办 / 违规档案）。
 */
export default class ContentReview extends Model {
  /** 内容域：post_text（正文文本）/ post_image（配图）/ blog_cover（博客头图）。 */
  scope() {
    return Model.attribute('scope').call(this);
  }

  /** 状态：passed（待抽查）/ reverted（已驳回，违规档案）/ superseded（已过期失效）。 */
  status() {
    return Model.attribute('status').call(this);
  }

  /** 放行来源：aliyun_pass（阿里云判定通过）/ fail_pass（调用失败降级放行）。 */
  source() {
    return Model.attribute('source').call(this);
  }

  /** 失效原因码（仅 status=superseded 时有值），可空。 */
  supersededReason() {
    return Model.attribute('supersededReason').call(this);
  }

  /** 管理员填写的复核备注（驳回原因），可空。 */
  reviewNote() {
    return Model.attribute('reviewNote').call(this);
  }

  /** 记录创建时间。 */
  createdAt() {
    return Model.attribute('createdAt', value => value ? new Date(value) : null).call(this);
  }
}
flarum.reg.add('jiedh-content-review', 'forum/models/ContentReview', ContentReview);